var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{attrs:{"id":"load_screen"}},[_vm._m(0)]):_vm._e(),(_vm.loaded)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-content"})])
}]

export { render, staticRenderFns }